import React, { useEffect, useRef, useState } from "react";
import Player from "@madzadev/audio-player";
import "@madzadev/audio-player/dist/index.css";
import "./App.css";

/*
 * PORTADA DE MALDITOS ANIMALES
 * Conservamos las pistas y los vínculos originales del sitio.
 * Enlaces de las obras configurados con las direcciones compartidas por el autor.
 */
const BOOK_PDF_URL = "https://malditosanimales.com.ar/libro/malditosanimales.pdf";
// Estas rutas surgen del index.html de El Diario de Nadie.
// La imagen usa la URL publica para poder verse tambien con npm start.
const DAILY_DIARY_COVER_URL = "https://malditosanimales.com.ar/diario/img/tapa_actual.png";
const DAILY_DIARY_EDITION_URL = "/diario/scripts/editorial.json";
const FALLBACK_DIARY_COVER_URL =
  "https://www.malditosanimales.com.ar/Discografia/tapas/diario.png";

const albums = [
  {
    id: 1,
    title: "Big Mamarracho",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/bigmamarracho.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/01 - Antes de Nacer.mp3",
        title: "01 - Antes de nacer",
        tags: ["Acústico Filosofal"],
        filename: "01 - Antes de Nacer.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/02 - ElTiempo Da La Razon.mp3",
        title: "02 - El tiempo da la razón",
        tags: ["Electropop acusatorio"],
        filename: "02 - ElTiempo Da La Razon.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/03 - Hay algo que no está bien.mp3",
        title: "03 - Hay algo que no está bien",
        tags: ["Distorsión Mental"],
        filename: "03 - Hay algo que no está bien.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/04 - This is a mamarracho.mp3",
        title: "04 - This is a mamarracho",
        tags: ["Guacarock"],
        filename: "04 - This is a mamarracho.mp3",
        videoUrl: "https://www.youtube.com/watch?v=tOfQ0V6qhZw",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/05 - Podria Haberte Ido A Buscar.mp3",
        title: "05 - Podría haberte ido a buscar",
        tags: ["Weird Country"],
        filename: "05 - Podria Haberte Ido A Buscar.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/06 - EstaTodo Mal.mp3",
        title: "06 - Está todo mal",
        tags: ["Simil Radio"],
        filename: "06 - EstaTodo Mal.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/07 - Soy Una Nube De Atomos.mp3",
        title: "07 - Soy una nube de átomos",
        tags: ["Freak Folk"],
        filename: "07 - Soy Una Nube De Atomos.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/08 - Pena en alma.mp3",
        title: "08 - Pena en alma",
        tags: ["Urban Rock"],
        filename: "08 - Pena en alma.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/09 - Se termina la esperanza.mp3",
        title: "09 - Se termina la esperanza",
        tags: ["Low Res Techno"],
        filename: "09 - Se termina la esperanza.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/10 - Mate con azúcar.mp3",
        title: "10 - Mate con azúcar",
        tags: ["Useless Song"],
        filename: "10 - Mate con azúcar.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/11 - Fade out de un amor que se fue.mp3",
        title: "11 - Fade out de un amor que se fue",
        tags: ["Not Live'N'Roll"],
        filename: "11 - Fade out de un amor que se fue.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/bigmamarracho/12 - No tiene carne.mp3",
        title: "12 - No tiene carne",
        tags: ["Cumbia Espectral"],
        filename: "12 - No tiene carne.mp3",
      },
    ],
  },
  {
    id: 2,
    title: "Pesadillear",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/pesadillear.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/01 - Alfombra - Botavema 3 - Lounge version.mp3",
        title: "01 - Alfombra",
        tags: ["Revival lounge"],
        filename: "01 - Alfombra - Botavema 3 - Lounge version.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/02 - Calamidad.mp3",
        title: "02 - Calamidad",
        tags: ["Electric sorrow"],
        filename: "02 - Calamidad.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/03 - Canción inútil (para calmar el dolor).mp3",
        title: "03 - Canción inútil (para calmar el dolor)",
        tags: ["Acoustic pain"],
        filename: "03 - Canción inútil (para calmar el dolor).mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/04 - La chica  de la mancha de café.mp3",
        title: "04 - La chica de la mancha de café",
        tags: ["Dope pop rock"],
        filename: "04 - La chica de la mancha de café.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/05 - La realidad.mp3",
        title: "05 - La realidad",
        tags: ["Explicit tears"],
        filename: "05 - La realidad.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/06 - Me dibuja el camino la luna.mp3",
        title: "06 - Me dibuja el camino la luna",
        tags: ["Default hit"],
        filename: "06 - Me dibuja el camino la luna.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/07 - Noches ciegas.mp3",
        title: "07 - Noches ciegas",
        tags: ["Female white noise"],
        filename: "07 - Noches ciegas.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/pesadillear/08 - Pesadillear.mp3",
        title: "08 - Pesadillear",
        tags: ["Final grey dead"],
        filename: "08 - Pesadillear.mp3",
      },
    ],
  },
  {
    id: 3,
    title: "Tres",
    cover: "https://www.malditosanimales.com.ar/Discografia/tapas/tres.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/01 - Caer en el vacio de la ignominia.mp3",
        title: "01 - Caer en el vacío de la ignominia",
        tags: ["Crisis song"],
        filename: "01 - Caer en el vacío de la ignominia.mp3",
        videoUrl: "https://youtu.be/q3ftj5egX_k",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/02 - Cosas que le pasan a la gente.mp3",
        title: "02 - Cosas que le pasan a la gente",
        tags: ["Evil of many"],
        filename: "02 - Cosas que le pasan a la gente.mp3",
        videoUrl: "https://youtu.be/yqln1rlIXqk",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/03 - Cómo pasa el tiempo.mp3",
        title: "03 - Cómo pasa el tiempo",
        tags: ["Pass by the time"],
        filename: "03 - Cómo pasa el tiempo.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/04 - Dónde está la realidad.mp3",
        title: "04 - Dónde está la realidad",
        tags: ["Unreal song"],
        filename: "04 - Dónde está la realidad.mp3",
        videoUrl: "https://youtu.be/W8bT5dB5wV8",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/05 - Fuera de mí.mp3",
        title: "05 - Fuera de mí",
        tags: ["External beat"],
        filename: "05 - Fuera de mí.mp3",
        videoUrl: "https://youtu.be/7BfqOtU3-uA",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/06 - Hola Que tal.mp3",
        title: "06 - Hola Que tal",
        tags: ["Acoustic greeting"],
        filename: "06 - Hola Que tal.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/07 - Oslo.mp3",
        title: "07 - Oslo",
        tags: ["Oslo way of life"],
        filename: "07 - Oslo.mp3",
        videoUrl: "https://youtu.be/Uw8bYGKZ9RQ",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/08 - Todo es natural.mp3",
        title: "08 - Todo es natural",
        tags: ["Ecological and roll"],
        filename: "08 - Todo es natural.mp3",
        videoUrl: "https://youtu.be/wijzdsY8MIg",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/tres/09 - Todo se cae.mp3",
        title: "09 - Todo se cae",
        tags: ["Falling down music"],
        filename: "09 - Todo se cae.mp3",
        videoUrl: "https://youtu.be/4ochJshFMxE",
      },
    ],
  },
  {
    id: 4,
    title: "Malditos Animales y La Pesada",
    cover: "https://www.malditosanimales.com.ar/Discografia/tapas/maylp.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Anoche soñé con vos- MAyLP.mp3",
        title: "Anoche soñé con vos",
        tags: ["Vinilo Onírico"],
        filename: "Anoche soñé con vos- MAyLP.mp3"
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Blues de Sábado Sin Ganas - MAyLP.mp3",
        title: "Blues de Sábado Sin Ganas",
        tags: ["Psicoblues"],
        filename: "Blues de Sábado Sin Ganas - MAyLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Diez horas por segundo  - MAYLP.mp3",
        title: "Diez horas por segundo ",
        tags: ["Ansiedad rock"],
        filename: "Diez horas por segundo  - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/La carne se está cociendo - MAYLP.mp3",
        title: "La carne se está cociendo",
        tags: ["Rock a punto"],
        filename: "La carne se está cociendo - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Mi abrazo tiene tu forma - MAYLP.mp3",
        title: "Mi abrazo tiene tu forma",
        tags: ["Folkrockdistort"],
        filename: "Mi abrazo tiene tu forma - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/No viene nada - MAYLP.mp3",
        title: "No viene nada",
        tags: ["Angustia existencial rock"],
        filename: "No viene nada - MAYLP.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/maylp/Sueños Raros - MAYLP.mp3",
        title: "Sueños Raros",
        tags: ["No sabés lo que soñé rock"],
        filename: "Sueños Raros - MAYLP.mp3",
      },
    ],
  },
  {
    id: 5,
    title: "La materia no se ordena como espero",
    cover: "https://www.malditosanimales.com.ar/Discografia/tapas/lmnsoce.jpg",
    tracks: [
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/01_Situación de caos.mp3",
        title: "01_Situación de caos",
        tags: ["Electronic naif No wave"],
        filename: "01_Situación de caos.mp3"
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/02_La chica de la mancha de café.mp3",
        title: "02_La chica de la mancha de café",
        tags: ["Desperate naif"],
        filename: "02_La chica de la mancha de café.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/03_No tengo corazón.mp3",
        title: "03_No tengo corazón",
        tags: ["Acoustic naif"],
        filename: "03_No tengo corazón.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/04_¿Dónde queda la felicidad_.mp3",
        title: "04_¿Dónde queda la felicidad?",
        tags: ["Naif no wave"],
        filename: "04_¿Dónde queda la felicidad_.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/05_Muy de vez en cuando.mp3",
        title: "05_Muy de vez en cuando",
        tags: ["Electronic naif tango"],
        filename: "05_Muy de vez en cuando.mp3",
      },
      {
        url: "https://www.malditosanimales.com.ar/Discografia/mp3/lmnsoce/06_La materia no se ordena como espero.mp3",
        title: "06_La materia no se ordena como espero",
        tags: ["Electronic no wave"],
        filename: "06_La materia no se ordena como espero.mp3",
      }
    ],
  },
];

// -----------------------------
// 🖼️ Extras (link + audios WAV)
// -----------------------------
const extras = [
  {
    id: "ext-link",
    title: "99 No Gardeles",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "link",
    url: "https://opensea.io/collection/99nogardeles",
  },
  {
    id: "ext-audio-1",
    title: "Sobre 99 NG (Audio 1)",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "audio",
    url: "https://www.malditosanimales.com.ar/Discografia/mp3/podcasts/99NoGardeles01.wav",
  },
  {
    id: "ext-audio-2",
    title: "Sobre 99 NG (Audio 2)",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "audio",
    url: "https://www.malditosanimales.com.ar/Discografia/mp3/podcasts/99NoGardeles02.wav",
  },
  {
    id: "ext-audio-3",
    title: "Sobre 99 NG (Audio 3)",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/Gardel.png",
    type: "audio",
    url: "https://www.malditosanimales.com.ar/Discografia/mp3/podcasts/99NoGardeles03.wav",
  },
  {
    id: "ext-link-diario",
    title: "El diario de nadie",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/diario.png",
    type: "link",
    url: "https://malditosanimales.com.ar/diario/index.html",
  },
  {
    id: "ext-link-maq",
    title: "Máquina de escribir",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/maquina.png",
    type: "link",
    url: "https://www.malditosanimales.com.ar/maquina/",
  },
  {
    id: "ext-link-poetica",
    title: "Poética Artificial",
    cover:
      "https://www.malditosanimales.com.ar/Discografia/tapas/poeticaartificial.png",
    type: "pdf",
    url: "https://www.malditosanimales.com.ar/maquina/poeticaartificial.pdf",
  },
];

const playerColors = {
  tagsBackground: "#444",
  tagsText: "#ccc",
  tagsBackgroundHoverActive: "#666",
  tagsTextHoverActive: "#eee",
  searchBackground: "#222",
  searchText: "#ccc",
  searchPlaceHolder: "#555",
  playerBackground: "#111",
  titleColor: "#ccc",
  timeColor: "#ccc",
  progressSlider: "#b87b55",
  progressUsed: "#efe1ca",
  progressLeft: "#333",
  bufferLoaded: "#444",
  volumeSlider: "#666",
  volumeUsed: "#ccc",
  volumeLeft: "#333",
  playlistBackground: "#111",
  playlistText: "#ddd",
  playlistBackgroundHoverActive: "#222",
  playlistTextHoverActive: "#fff",
};

const PROJECTS = [
  { id: "libro", name: "Malditos Animales", sub: "El libro que empezó todo" },
  { id: "gardeles", name: "99 No Gardeles", sub: "Una colección que se multiplica" },
  { id: "musica", name: "Música", sub: "Discos, canciones y accidentes" },
  { id: "diario", name: "El Diario de Nadie", sub: "Últimas noticias de la Humanidad" },
  { id: "maquina", name: "Máquina de escribir", sub: "Un artefacto para palabras" },
  { id: "poetica", name: "Poética Artificial", sub: "Libro digital" },
];

const findExtra = (id) => extras.find((item) => item.id === id);
const DIARY_URL = findExtra("ext-link-diario").url;
const TYPEWRITER_URL = findExtra("ext-link-maq").url;
const POETICA_URL = findExtra("ext-link-poetica").url;
const GARDELES_URL = findExtra("ext-link").url;
const GARDELES_COVER = findExtra("ext-link").cover;
const TYPEWRITER_COVER = findExtra("ext-link-maq").cover;
const POETICA_COVER = findExtra("ext-link-poetica").cover;

function chooseFeatured() {
  // Mantiene distinto el protagonista respecto de la última visita,
  // incluso al volver a cargar la página. La portada no necesita un backend.
  let last = null;
  try {
    last = window.localStorage.getItem("ma-ultima-obra-protagonista");
  } catch (_error) {
    // La página sigue funcionando con el almacenamiento deshabilitado.
  }
  const candidates = PROJECTS.filter((project) => project.id !== last);
  const picked = candidates[Math.floor(Math.random() * candidates.length)].id;
  try {
    window.localStorage.setItem("ma-ultima-obra-protagonista", picked);
  } catch (_error) {
    // No es necesario guardar la preferencia para mostrar el collage.
  }
  return picked;
}

function ClawMark({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 110 114" aria-hidden="true" focusable="false">
      <path d="M8 99 37 5 31 48 46 20 31 108 25 72Z" />
      <path d="M40 107 65 7 60 50 78 18 64 109 57 74Z" />
      <path d="M72 108 98 15 93 56 107 30 95 105 88 80Z" />
    </svg>
  );
}

function App() {
  const [featured] = useState(chooseFeatured);
  const [indexOpen, setIndexOpen] = useState(() => window.innerWidth > 710);
  const [panel, setPanel] = useState(null);
  const [currentAlbum, setCurrentAlbum] = useState(4); // La materia no se ordena como espero.
  const [downloadsOpen, setDownloadsOpen] = useState(false);
  const [playingUrl, setPlayingUrl] = useState(null);
  const [playingTitle, setPlayingTitle] = useState("");
  const [audioError, setAudioError] = useState("");
  // La marca temporal fuerza una lectura nueva de la imagen en cada visita.
  const [diaryImage, setDiaryImage] = useState(
    () => `${DAILY_DIARY_COVER_URL}?v=${Date.now()}`
  );
  const [diaryEdition, setDiaryEdition] = useState(null);
  const [visitCount, setVisitCount] = useState(null);
  const audioRef = useRef(null);
  const previousAudioUrl = useRef("");
  const previousSongUrl = useRef("");

  const featuredProject = PROJECTS.find((item) => item.id === featured);
  const displayProjects = [
    featuredProject,
    ...PROJECTS.filter((item) => item.id !== featured),
  ];

  // Recupera el titular y la fecha desde el JSON que utiliza el diario real.
  // En localhost puede no existir /diario; el collage igualmente muestra la tapa.
  useEffect(() => {
    const controller = new AbortController();
    fetch(DAILY_DIARY_EDITION_URL, {
      cache: "no-store",
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Diario: HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (!data || typeof data !== "object") return;
        setDiaryEdition({
          title: typeof data.titulo === "string" ? data.titulo.trim() : "",
          date: typeof data.generado === "string" ? data.generado : "",
        });
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.warn("No se pudo leer la edición actual del diario:", error);
        }
      });
    return () => controller.abort();
  }, []);

  // El total se guarda en el servidor, no en localStorage.
  // PHP usa una cookie de 30 minutos para no sumar varias veces la misma visita.
  useEffect(() => {
    const controller = new AbortController();
    fetch("/visitas.php", {
      cache: "no-store",
      credentials: "same-origin",
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Contador: HTTP ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (Number.isSafeInteger(data.total) && data.total >= 0) {
          setVisitCount(data.total);
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.warn("Contador no disponible (requiere PHP en el servidor):", error);
        }
      });
    return () => controller.abort();
  }, []);

  useEffect(() => {
    const audio = new Audio();
    audio.preload = "none";
    audioRef.current = audio;
    const onEnd = () => {
      setPlayingUrl(null);
      setPlayingTitle("");
    };
    audio.addEventListener("ended", onEnd);
    return () => {
      audio.pause();
      audio.removeEventListener("ended", onEnd);
      audio.removeAttribute("src");
      audio.load();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!panel) return undefined;
    const onEscape = (event) => {
      if (event.key === "Escape") setPanel(null);
    };
    document.addEventListener("keydown", onEscape);
    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEscape);
      document.body.style.overflow = oldOverflow;
    };
  }, [panel]);

  function stopAudio() {
    if (audioRef.current) audioRef.current.pause();
    setPlayingUrl(null);
    setPlayingTitle("");
    setAudioError("");
  }

  function playAudio(url, title) {
    const audio = audioRef.current;
    if (!audio) return;
    setAudioError("");
    if (previousAudioUrl.current === url && !audio.paused) {
      stopAudio();
      return;
    }
    audio.pause();
    previousAudioUrl.current = url;
    audio.src = url;
    audio.currentTime = 0;
    audio.play().then(() => {
      setPlayingUrl(url);
      setPlayingTitle(title);
    }).catch(() => {
      setPlayingUrl(null);
      setPlayingTitle("");
      setAudioError("No se pudo reproducir el audio. Revisá el archivo o su dirección.");
    });
  }

  function playRandomSong() {
    const songs = albums.flatMap((album) => album.tracks);
    const options = songs.filter((song) => song.url !== previousSongUrl.current);
    const song = options[Math.floor(Math.random() * options.length)];
    previousSongUrl.current = song.url;
    playAudio(song.url, song.title);
  }

  function openPanel(name) {
    stopAudio(); // Evita dos pistas simultáneas con el reproductor completo.
    setDownloadsOpen(false);
    setPanel(name);
  }

  function closePanel() {
    stopAudio();
    setPanel(null);
  }

  function goToArtwork(event, id) {
    event.preventDefault();
    setIndexOpen(false);
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      window.history.replaceState(null, "", `#${id}`);
    }
  }

  const podcasts = extras.filter((item) => item.type === "audio");
  const currentAlbumData = albums[currentAlbum];

  return (
    <div className="portfolio">
      <a className="skip-link" href="#collage">Ir a las obras</a>
      <div className="paper-mark paper-mark-one" aria-hidden="true" />
      <div className="paper-mark paper-mark-two" aria-hidden="true" />

      <main id="collage" className="collage-layout">
        <header className="site-signature" aria-label="Malditos Animales">
          <ClawMark className="signature-claws" />
          <div className="signature-words">
            <h1>MALDITOS<br />ANIMALES</h1>
            <span className="signature-sub">archivo inestable de cosas hechas</span>
          </div>
          <span className="scribble scribble-logo" aria-hidden="true">¿orden?</span>
        </header>

        <aside className={`index-paper ${indexOpen ? "is-open" : ""}`} aria-label="Índice mecanografiado">
          <button
            className="index-toggle"
            type="button"
            aria-expanded={indexOpen}
            aria-controls="portfolio-index"
            onClick={() => setIndexOpen(!indexOpen)}
          >
            <span>ÍNDICE</span><span>{indexOpen ? "[−]" : "[+]"}</span>
          </button>
          <nav id="portfolio-index" className="index-links" hidden={!indexOpen} aria-label="Ir a una obra">
            {displayProjects.map((item, number) => (
              <a href={`#${item.id}`} key={item.id} onClick={(event) => goToArtwork(event, item.id)}>
                <span>{String(number + 1).padStart(2, "0")}.</span> {item.name}
              </a>
            ))}
            <a href="#autor" onClick={(event) => goToArtwork(event, "autor")}>07. Sobre el responsable</a>
          </nav>
          <p className="index-fineprint">orden sujeto a desperfectos</p>
        </aside>

        <div className="collage-pieces">
          {displayProjects.map((project, position) => (
            <article
              id={project.id}
              key={project.id}
              className={`piece piece-${project.id} ${project.id === featured ? "is-featured" : ""}`}
              style={{ "--piece-index": position }}
            >
              <span className="adhesive" aria-hidden="true" />
              {project.id === featured && <span className="feature-stamp">HOY ME TOCA</span>}

              {project.id === "libro" && (
                <>
                  <div className="book-art" aria-hidden="true">
                    <span className="book-spine" />
                    <span className="book-author">UNA OBRA DE PABLO TOLOSA</span>
                    <strong>MALDITOS<br />ANIMALES</strong>
                    <ClawMark className="book-claws" />
                    <span className="book-year">FER · 2010</span>
                  </div>
                  <div className="piece-caption">
                    <h2>{project.name} <small>(el libro)</small></h2>
                    <p>Antes que el sitio, estuvo el libro.</p>
                    <button className="paper-action" onClick={() => openPanel("libro")}>Explorar el libro ↗</button>
                  </div>
                </>
              )}

              {project.id === "gardeles" && (
                <>
                  <div className="gardeles-art">
                    <img src={GARDELES_COVER} alt="Imagen de la colección 99 No Gardeles" loading="lazy" />
                    <span className="gardeles-number" aria-hidden="true">99</span>
                  </div>
                  <div className="piece-caption">
                    <h2>{project.name}</h2>
                    <p>NFT, retratos y variaciones.</p>
                    <button className="paper-action" onClick={() => openPanel("gardeles")}>Ver colección y escuchar ↗</button>
                  </div>
                </>
              )}

              {project.id === "musica" && (
                <>
                  <div className="records-art" aria-label="Tapas de distintos discos de Malditos Animales">
                    <div className="record-vinyl" aria-hidden="true" />
                    <img className="record-cover record-back" src={albums[1].cover} alt="" loading="lazy" />
                    <img className="record-cover record-front" src={albums[4].cover} alt="Tapa de La materia no se ordena como espero" loading="lazy" />
                    <span className="record-burst" aria-hidden="true">♫</span>
                  </div>
                  <div className="piece-caption">
                    <h2>{project.name}</h2>
                    <p>Un archivo de canciones que no sabe quedarse quieto.</p>
                    <div className="piece-actions">
                      <button className="paper-action" onClick={playRandomSong}>▶ Tema al azar</button>
                      <button className="paper-action secondary-action" onClick={() => openPanel("musica")}>Discografía ↗</button>
                    </div>
                  </div>
                </>
              )}

              {project.id === "diario" && (
                <>
                  <div className="diary-art">
                    <div className="diary-masthead">EL DIARIO<br />DE NADIE</div>
                    <p>Últimas noticias de la Humanidad</p>
                    {diaryEdition?.date && (
                      <div className="diary-date">
                        EDICIÓN {diaryEdition.date.slice(0, 10).split("-").reverse().join("/")}
                      </div>
                    )}
                    {diaryEdition?.title && (
                      <div className="diary-headline">{diaryEdition.title}</div>
                    )}
                    <a
                      className="diary-cover-link"
                      href={DIARY_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Abrir la tapa actual de El Diario de Nadie"
                    >
                      <img
                        src={diaryImage}
                        alt="Ilustración de la tapa actual de El Diario de Nadie"
                        loading="lazy"
                        onError={() => {
                          if (diaryImage !== FALLBACK_DIARY_COVER_URL) {
                            setDiaryImage(FALLBACK_DIARY_COVER_URL);
                          }
                        }}
                      />
                    </a>
                    <span className="diary-stamp">HOY</span>
                  </div>
                  <div className="piece-caption">
                    <h2>{project.name}</h2>
                    <p>Una publicación que continúa mientras pueda.</p>
                    <a className="paper-action" href={DIARY_URL} target="_blank" rel="noopener noreferrer">Abrir el diario actual ↗</a>
                  </div>
                </>
              )}

              {project.id === "maquina" && (
                <>
                  <div className="machine-art">
                    <div className="machine-sheet">
                      <span className="type-line">La realidad está sobrevalorada...</span>
                    </div>
                    <img src={TYPEWRITER_COVER} alt="Máquina de escribir" loading="lazy" />
                    <span className="machine-cursor" aria-hidden="true">▌</span>
                  </div>
                  <div className="piece-caption">
                    <h2>{project.name}</h2>
                    <p>Un mecanismo para que las palabras hagan cosas.</p>
                    <a className="paper-action" href={TYPEWRITER_URL} target="_blank" rel="noopener noreferrer">Probar la máquina ↗</a>
                  </div>
                </>
              )}

              {project.id === "poetica" && (
                <>
                  <div className="poetica-art">
                    <img src={POETICA_COVER} alt="Imagen de Poética Artificial" loading="lazy" />
                    <span className="poetica-glitch" aria-hidden="true">ERROR / BELLEZA</span>
                  </div>
                  <div className="piece-caption">
                    <h2>{project.name}</h2>
                    <p>Un libro para leer entre humanos y máquinas.</p>
                    <a className="paper-action" href={POETICA_URL} target="_blank" rel="noopener noreferrer">Abrir el libro ↗</a>
                  </div>
                </>
              )}
            </article>
          ))}

          <section className="author-note" id="autor" aria-labelledby="author-title">
            <span className="author-clip" aria-hidden="true">⌁</span>
            <p className="author-eyebrow">SOBRE EL RESPONSABLE</p>
            <h2 id="author-title">Pablo Tolosa</h2>
            <p>Escribo, compongo y programo. A veces salen libros, a veces canciones y a veces máquinas que se meten en el medio.</p>
            <p>Malditos Animales es el nombre que terminó quedándose con todo.</p>
            <span className="author-signature">continuará, probablemente.</span>
          </section>
        </div>

        <footer className="collage-footer">
          <span>MALDITOS ANIMALES · Esto no es un menú. Bueno, un poco sí.</span>
          <span className="visit-counter" title="Una visita nueva por sesión, después de 30 minutos de inactividad">
            VISITAS: {visitCount === null ? "—" : visitCount.toLocaleString("es-AR")}
          </span>
        </footer>
      </main>

      {(playingUrl || audioError) && (
        <div className="now-playing" role="status">
          {playingUrl && <span>♫ {playingTitle}</span>}
          {audioError && <span>{audioError}</span>}
          {playingUrl && <button type="button" onClick={stopAudio} aria-label="Detener audio">Detener ×</button>}
          {audioError && <button type="button" onClick={() => setAudioError("")} aria-label="Cerrar aviso">×</button>}
        </div>
      )}

      {panel && (
        <div className="modal-backdrop" onMouseDown={(event) => {
          if (event.target === event.currentTarget) closePanel();
        }}>
          <section className="modal-paper" role="dialog" aria-modal="true" aria-label={panel === "musica" ? "Discografía completa" : panel === "gardeles" ? "99 No Gardeles" : "Malditos Animales, el libro"}>
            <button className="modal-close" type="button" onClick={closePanel}>Cerrar ×</button>

            {panel === "musica" && (
              <div className="music-modal">
                <p className="modal-eyebrow">ARCHIVO SONORO</p>
                <h2>Discografía</h2>
                <div className="album-picker" role="group" aria-label="Elegir disco">
                  {albums.map((album, index) => (
                    <button
                      type="button"
                      key={album.id}
                      className={index === currentAlbum ? "album-choice selected" : "album-choice"}
                      onClick={() => {
                        setCurrentAlbum(index);
                        setDownloadsOpen(false);
                      }}
                      aria-pressed={index === currentAlbum}
                    >
                      <img src={album.cover} alt="" loading="lazy" />
                      <span>{album.title}</span>
                    </button>
                  ))}
                </div>
                <h3>{currentAlbumData.title}</h3>
                <div className="music-player-grid">
                  <img className="music-cover" src={currentAlbumData.cover} alt={`Tapa de ${currentAlbumData.title}`} />
                  <div className="full-player">
                    <Player
                      key={currentAlbumData.id}
                      trackList={currentAlbumData.tracks}
                      includeTags={false}
                      includeSearch={false}
                      customColorScheme={playerColors}
                    />
                  </div>
                </div>
                {currentAlbumData.tracks.some((track) => track.videoUrl) && (
                  <div className="album-videos">
                    <h4>Videos</h4>
                    {currentAlbumData.tracks.filter((track) => track.videoUrl).map((track) => (
                      <a key={track.url} href={track.videoUrl} target="_blank" rel="noopener noreferrer">▣ {track.title}</a>
                    ))}
                  </div>
                )}
                <button className="downloads-toggle" type="button" onClick={() => setDownloadsOpen(!downloadsOpen)} aria-expanded={downloadsOpen}>
                  {downloadsOpen ? "Ocultar descargas −" : "Mostrar descargas +"}
                </button>
                {downloadsOpen && (
                  <ul className="download-list">
                    {currentAlbumData.tracks.map((track) => (
                      <li key={track.url}><a href={track.url} download={track.filename} target="_blank" rel="noopener noreferrer">{track.title}</a></li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {panel === "gardeles" && (
              <div className="generic-modal">
                <p className="modal-eyebrow">COLECCIÓN / ARCHIVO</p>
                <h2>99 No Gardeles</h2>
                <img className="modal-art" src={GARDELES_COVER} alt="Imagen de 99 No Gardeles" />
                <p>La colección está publicada en OpenSea. También podés escuchar los audios que acompañan al proyecto.</p>
                <a className="modal-primary-link" href={GARDELES_URL} target="_blank" rel="noopener noreferrer">Visitar 99 No Gardeles ↗</a>
                <div className="podcasts">
                  <h3>Audios del proyecto</h3>
                  {podcasts.map((podcast) => (
                    <button key={podcast.id} type="button" onClick={() => playAudio(podcast.url, podcast.title)}>
                      {playingUrl === podcast.url ? "■ Detener" : "▶ Escuchar"} {podcast.title}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {panel === "libro" && (
              <div className="generic-modal book-modal">
                <p className="modal-eyebrow">EL ORIGEN DEL NOMBRE</p>
                <h2>Malditos Animales</h2>
                <p>El libro de 2010 dio nombre a este espacio y a una identidad artística que después reunió música, escritura y experimentos digitales.</p>
                <a className="modal-primary-link" href={BOOK_PDF_URL} target="_blank" rel="noopener noreferrer">Leer el libro ↗</a>
              </div>
            )}
          </section>
        </div>
      )}
    </div>
  );
}

export default App;
